import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/library/accordion";
import { Badge } from "@/components/ui/others/Badges";
import { ChevronDown } from "lucide-react";

export default function StatusSection({ child }: any) {
  // TODO: Replace with actual data from props or context
  const status = child?.status?.name;
  const subStatus = child?.subStatus?.name;

  return (
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem value="status-section" className="border-none">
        <AccordionTrigger className="text-b2-mid font-medium hover:no-underline px-0 py-3 !justify-start gap-2 items-center [&>svg]:translate-y-0">
          Status/sub status
        </AccordionTrigger>
        <AccordionContent className="px-0 pb-0 pl-2">
          <div className="bg-[#fcfcfc] border border-[#cdd1d0] rounded-xl h-10 px-3 py-2 flex items-center gap-2">
            <div className="flex gap-1 flex-1 min-w-0">
              <Badge
                variant="info"
                className="text-[12px] font-medium px-2 py-0.5 rounded-full shrink-0"
              >
                {status}
              </Badge>
              <Badge
                variant="warning"
                className="text-[12px] font-medium px-2 py-0.5 rounded-full shrink-0"
              >
                {subStatus}
              </Badge>
            </div>
            <ChevronDown
              size={24}
              className="text-[#505e59] shrink-0"
              strokeWidth={1.5}
            />
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
